// @ts-nocheck
import { ReactComponent as Icon } from '../../assets/icons/accordionIconLP.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" alt="Info" aria-label="Info" />;
}
